import { render } from "./LoadingView.vue?vue&type=template&id=270ae781&scoped=true&ts=true"
import script from "./LoadingView.vue?vue&type=script&lang=ts"
export * from "./LoadingView.vue?vue&type=script&lang=ts"

import "./LoadingView.vue?vue&type=style&index=0&id=270ae781&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ae781"],['__file',"src/components/LoadingView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270ae781"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270ae781', __exports__)) {
    api.reload('270ae781', __exports__)
  }
  
  module.hot.accept("./LoadingView.vue?vue&type=template&id=270ae781&scoped=true&ts=true", () => {
    api.rerender('270ae781', render)
  })

}


export default __exports__